const initialState = {
  dataCamionesRechazados: null,
  fechaDesde: null,
  fechaHasta: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'ACTUALIZAR_CAMIONES_RECHAZADOS':
      return {
        ...state,
        fechaDesde: action.fechaD,
        fechaHasta: action.fechaH
      }
    case 'CAMIONES_RECHAZADOS':
      return {
        ...state,
        dataCamionesRechazados: action.data
      }
    default:
      return state
  }
}
